import { render, staticRenderFns } from "./MyCommentItem.vue?vue&type=template&id=1225da2a&scoped=true"
import script from "./MyCommentItem.vue?vue&type=script&lang=js"
export * from "./MyCommentItem.vue?vue&type=script&lang=js"
import style0 from "./MyCommentItem.vue?vue&type=style&index=0&id=1225da2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1225da2a",
  null
  
)

export default component.exports